import React, { useContext } from "react";
import TimeTableContext from "../../../context/timeTableContext";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

function PressTable(props) {
  const context = useContext(TimeTableContext);
  console.log(context);
  let styleButton = {};
  if (context.state.firstHour != null && context.state.highHour) {
    return (
      <table className="table-press">
        <tr>
          <td>#</td>
          {context.state.daysOfTheWeekWeekly.map((elem) => {
            return <td style={{ textAlign: "center" }}>{elem}</td>;
          })}
        </tr>
        {context.state.highHour.map((h) => {
          return (
            <tr>
              <td style={{ padding: 5 }}>{h + context.state.firstHour}</td>
              {context.state.daysOfTheWeekNumeric.map((d) => {
                if (d == context.state.day && context.state.slot == h) {
                  styleButton = { backgroundColor: "#3f51b5" };
                } else {
                  styleButton = { backgroundColor: "" };
                }
                return (
                  <td>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        context.dispatch({
                          type: "SET_CURRENT_TIME",
                          payload: { day: d, slot: h },
                        });
                      }}
                      style={styleButton}
                    ></Button>
                  </td>
                );
              })}
            </tr>
          );
        })}
      </table>
    );
  } else {
    return (
      <div style={{ textAlign: "center", paddingTop: "100px" }}>
        <CircularProgress />
      </div>
    );
  }
}

export default PressTable;
